module.exports = __webpack_public_path__ + "img/Picture6.07631a0c.jpg";